<template>
    <PatientProfile
        :patientId    = "patientInfo.id"
        :name         = "patientInfo.name"
        :birth        = "patientInfo.birth"
        :age          = "patientInfo.age"
        :weight       = "patientInfo.weight"
        :lastExam     = "patientInfo.lastExam"
        :painArea     = "patientInfo.painArea"
        :showPainArea = "false"
    />
    <hr style="border:0; border-top:1.5px solid #c8c8c8; margin:12px 0;" />
    <div class="prescription-action-cards">
        <div class="prescription-action-card prescription-action-lightblue"  @click="showRegisterDetail(patientInfo.id, diagnosisId)">
            <div class="prescription-action-icon">
                <img src="@/assets/resource/svg/Register.svg" alt="등록 아이콘" />
            </div>
            <div class="prescription-action-label">새로 등록하기</div>
        </div>
        <div class="prescription-action-card prescription-action-blue" @click="showLoadDetail(patientInfo.id)">
            <div class="prescription-action-icon">
                <img src="@/assets/resource/icon/Load.png" alt="불러오기 아이콘" class="icon-filter"/>
            </div>
            <div class="prescription-action-label">이전 데이터<br/>불러오기</div>
        </div>
    </div>
</template>
<script setup>
    defineOptions({
        meta: {
            title: '통증 케어 프로토콜',
            segmentKey: 'patientId'
        }
    })

    import PatientProfile        from "@/components/common/PatientProfile.vue"
    import {useRoute, useRouter} from "vue-router";
    import {onMounted, ref}      from "vue";
    import api, { urls }         from "@/api";
    import { commonUtils }       from "@/utils/commonUtils";
    import { useAppAlert }       from '@/composables/useAppAlert'

    const { showAlert } = useAppAlert()

    const route       = useRoute()
    const router      = useRouter()
    const patientInfo = ref({})
    const diagnosisId = ref(null)

    async function PatientData(id, diagnosisId) {
        try {
            const params = {
                id: id,
                diagnosisId: diagnosisId
            };

            const res = await api.post(urls.patientList.patientData, params);
            const data = res.data.list ? res.data.list[0] : res.data;

            // [1] 환자 프로필용 데이터
            patientInfo.value = {
                id       : data.patient_id,
                name     : data.name,
                birth    : data.dob || '',
                age      : commonUtils.calcAge(data.dob),
                weight   : data.weight,
                lastExam : data.created_at ? data.created_at.split('T')[0] : '',
                painArea : data.pain_area || ''
            };
        } catch (err) {
            showAlert("환자 정보 불러오는데 실패했습니다.");
        }
    }

    function showRegisterDetail(idFromRoute,diagnosisId) {
        router.push({
            path: `/patientlist/prescriptionRegister/${idFromRoute}`,
            query: { diagnosisId: diagnosisId }
        })
    }

    function showLoadDetail(idFromRoute) {
        router.push({
            path: `/patientlist/prescriptionHistory/${idFromRoute}`
        })
    }

    onMounted(() => {
        const idFromRoute = route.params.patientId;
        // const diagnosisId = route.query.diagnosisId;
        const diagId = route.query.diagnosisId
        diagnosisId.value = diagId
        // PatientData(idFromRoute);  // 환자 프로필 세팅
        PatientData(idFromRoute,diagId);  // 환자 프로필 세팅
    })
</script>